import Utils from "./Utils";

export default class Hint {
  constructor(container, translations) {
    this.isSmallScreen = Utils.isSmallOrMediumLayout();
    this.container = container;
    this.text = this.container.querySelector("p");
    this.state = "";
    this.NUM_PEN_STROKES_BEFORE_COLOR_HINT = 5;
    this.NUM_COLOR_DOTS_BEFORE_COLORIZE_HINT = 3;
    this.NUM_MAGIC_STROKES_BEFORE_PEN_HINT = 3;
    this.numMagicStrokes = 0;
    this.numPenStrokes = 0;
    this.numColorDots = 0;
    this.highligtedElement = null;
    this.messages = {
      start_draw: translations.hint_start_draw,
      add_color: translations.hint_add_color,
      colorize: translations.hint_colorize,
      use_pen: translations.hint_use_pen,
      sketch_panel: translations.hint_sketch_panel,
      try_it_yourself: translations.try_it_yourself,
    };
  }

  show() {
    // do nothing if all the hints have been shown
    if (this.state === "complete") return;

    this.container.classList.add("animate-opacity");
    // disable the tooltip for this element
    if (this.highligtedElement)
      this.highligtedElement.querySelector("span.tooltiptext").style.display =
        "none";
  }

  forceShow(message) {
    const text = this.messages[message];
    this.text.innerText = text;
    this.container.classList.add("animate-opacity");
  }
  forceTranslate(element) {
    const elemPosition = element.getBoundingClientRect();
    this.container.style.left = `${
      elemPosition.left + elemPosition.width / 2
    }px`;
    this.container.style.transform = "translateX(-50%)";
  }

  hide() {
    this.container.classList.remove("animate-opacity");
    if (this.highligtedElement) {
      // reactivate tooltip
      if (this.highligtedElement.querySelector("span")) this.highligtedElement.querySelector("span").style.display = "block";
      this.highligtedElement = null;
    }
  }

  reset() {
    this.isSmallScreen = Utils.isSmallOrMediumLayout();
    // if it's the add_color state and the layout if mobile:
    if (this.state === "add_color" && Utils.isSmallOrMediumLayout()) {
      this.moveTo(document.querySelector("li.color"));
    }

    // if it's the colorize hint, replace it
    if (this.state === "colorize") {
      this.moveTo(document.querySelector(".colorize"));
    }
  }

  setComplete() {
    this.state = "complete";
  }

  setHint(step) {
    if (this.state === "complete") return;
    this.state = step;
    const text = this.messages[step];
    this.text.innerText = text;
  }

  addArrow() {
    this.container.classList.add("arrow");
  }

  removeArrow() {
    this.container.classList.remove("arrow");
  }

  setArrowDown() {
    this.container.classList.add("down");
    this.container.classList.remove("up");
    this.container.classList.remove("left");
  }

  setArrowUp() {
    this.container.classList.add("up");
    this.container.classList.remove("down");
    this.container.classList.remove("left");
  }

  setArrowLeft() {
    this.container.classList.add("left");
    this.container.classList.remove("up");
    this.container.classList.remove("down");
  }

  moveTo(element) {
    // mobile version
    const elemPosition = element.getBoundingClientRect();
    if (this.isSmallScreen) {
      // add an arrow to the tooltip
      this.addArrow();
      this.setArrowDown();
      this.container.style.position = "absolute";
      this.container.style.bottom = "auto";
      this.container.style.zIndex = "10";
      // we rest to 0 before we measure the container
      // otherwise this causes bugs (!)
      this.container.style.left = "0px";
      // then, we do the calculation
      const val =
        elemPosition.left -
        this.container.clientWidth / 2 +
        elemPosition.width / 2;
      this.container.style.left = `${Math.max(10, val)}px`;
      if (val < 10) {
        document.documentElement.style.setProperty(
          "--arrow_left",
          Math.abs(val - 10 - 4) + "px"
        );
      } else {
        document.documentElement.style.setProperty("--arrow_left", "4px");
      }

      // for colorize: display tooltip at bottom
      if (this.state === "colorize") {
        this.setArrowUp();
        this.container.style.top = `${
          elemPosition.top + elemPosition.height + 12
        }px`;
      }
      // else : display tooltip on top
      else {
        this.setArrowDown();
        this.container.style.top = `${
          elemPosition.top - elemPosition.height - 12
        }px`;
      }
    }
    // desktop version
    else {
      // if it's the colorize hint, display it centered and with an arrow.
      if (this.state === "colorize") {
        this.addArrow();
        this.setArrowUp();
        this.container.style.left = `${
          elemPosition.left -
          this.container.clientWidth / 2 +
          elemPosition.width / 2
        }px`;
        this.container.style.top = `${
          elemPosition.top + elemPosition.height + 12
        }px`;
      }
      // for other hints
      else {
        //this.removeArrow();
        this.container.style.position = "absolute";
        this.container.style.bottom = "auto";
        this.container.style.zIndex = "10";
        this.container.style.left = `${
          elemPosition.left + elemPosition.width + 12
        }px`;
        this.container.style.top = `${elemPosition.top}px`;
      }
    }
    this.highligtedElement = element;
  }

  countMagicStroke() {
    this.numMagicStrokes++;
    // if (this.numMagicStrokes >= this.NUM_MAGIC_STROKES_BEFORE_COLOR_HINT) {
    //   this.setHint("add_color");
    //   this.show();
    // }
    if (this.numMagicStrokes >= this.NUM_MAGIC_STROKES_BEFORE_PEN_HINT) {
      // this.setHint("use_pen");
      this.show();
    }
  }

  countPenStroke() {
    this.numPenStrokes++;
    if (this.numPenStrokes >= this.NUM_PEN_STROKES_BEFORE_COLOR_HINT) {
      // this.setHint("add_color");
      this.show();
    }
  }

  countColorDot() {
    this.numColorDots++;
    if (this.numColorDots > this.NUM_COLOR_DOTS_BEFORE_COLORIZE_HINT) {
      this.show();
    }
  }
}
